/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureSnapshotSortCriteria {
    getFixupPrototypeFunction() { return TagPostureSnapshotSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<TagPostureSnapshotSortCriteria>): TagPostureSnapshotSortCriteria {
        let obj = Object.assign(new TagPostureSnapshotSortCriteria(), model);
        TagPostureSnapshotSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureSnapshotSortCriteria>): TagPostureSnapshotSortCriteria {
        if (!model) return null;
        return TagPostureSnapshotSortCriteria.newInstance(<TagPostureSnapshotSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureSnapshotSortCriteria) {
        if (!obj) return;

        models.TagPostureSnapshotSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureSnapshotSortCriteria): boolean {
        Object.setPrototypeOf(obj, TagPostureSnapshotSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.TagPostureSnapshotSortColumn;

    ascending: boolean;

}
